import { render, staticRenderFns } from "./TrainPlanDatabaseManagement.vue?vue&type=template&id=ec1bfd38&scoped=true&"
import script from "./TrainPlanDatabaseManagement.vue?vue&type=script&lang=js&"
export * from "./TrainPlanDatabaseManagement.vue?vue&type=script&lang=js&"
import style0 from "./TrainPlanDatabaseManagement.vue?vue&type=style&index=0&id=ec1bfd38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1bfd38",
  null
  
)

export default component.exports